'use client';
import React, { useEffect, useState } from 'react';
import FAQAccordion from '@/components/FAQAccordion';
import { createClient } from '@/lib/supabase/client';

const DEFAULT_FAQS = [
  { q: 'How quickly can I launch a campaign?', a: 'Once payment is confirmed, your campaign goes live within 2 hours. Our team reviews your product details and guidelines to ensure quality before activation.' },
  { q: 'Are the reviewers real verified users?', a: 'Yes. Every reviewer completes KYC verification with Aadhaar/PAN, links their Amazon/Flipkart account, and has a minimum review history. We reject fake accounts automatically.' },
  { q: 'How does AI quality checking work?', a: 'Every submitted review is analyzed by AI for authenticity, coherence, specificity, and honesty. Reviews scoring below 70% are rejected and the reviewer is asked to rewrite.' },
  { q: 'Do I get a GST invoice?', a: 'Yes. A GST-compliant invoice is generated automatically upon payment and sent to your registered email. All our transactions are GST-compliant.' },
  { q: 'Can I target reviewers in specific cities?', a: 'Yes, on Growth and Enterprise plans you can target reviewers by city and by demographic.' },
  { q: 'What if a reviewer submits a poor quality review?', a: 'Our AI flags it. You can reject it from your dashboard. The reviewer must resubmit or forfeit their reward. You only pay for approved, quality reviews.' },
];

export default function BrandsFAQ() {
  const [faqs, setFaqs] = useState(DEFAULT_FAQS);

  useEffect(() => {
    const supabase = createClient();
    supabase?.from('platform_settings')?.select('value')?.eq('key', 'brands_faq')?.maybeSingle()?.then(({ data }) => {
        if (data?.value) {
          try { setFaqs(JSON.parse(data?.value)); } catch {}
        }
      });
  }, []);

  return (
    <section className="section-py bg-background">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary bg-primary-container px-3 py-1 rounded-full mb-3">
            FAQ
          </span>
          <h2 className="font-heading font-bold text-foreground" style={{ fontSize: 'clamp(1.5rem, 3vw, 2rem)' }}>
            Brand Questions Answered
          </h2>
        </div>
        <FAQAccordion items={faqs} />
      </div>
    </section>
  );
}